import React, { memo } from "react";

import { SvgIcon } from "@origin-digital/ods-icons";

const IconStoreys = memo(() => {
  return (
    <>
      <SvgIcon
        data-id="icon-storeys"
        size="small"
        viewBox="0 0 21 17"
        color="neutral"
      >
        <path
          d="M3.65332 17V9H0.65332L10.6533 0L20.6533 9H17.6533V17H15.6533V15H5.65332V17H3.65332ZM8.10332 5H13.2033L10.6533 2.7L8.10332 5ZM5.65332 9H15.6533V7.2L15.4283 7H5.87832L5.65332 7.2V9ZM5.65332 13H15.6533V11H5.65332V13Z"
          fill="#232323"
        />
      </SvgIcon>
    </>
  );
});

export { IconStoreys };
